<template>
  <div class="content">
    <h3>iCalendar abonnement af din arbejdskalender</h3>
    <p>
      Hvis du besøger denne side på den tynde klient kan du
      <a :href="generateUrl()"
        >klikke her og Outlook åbner automatisk din kalender.</a
      >
    </p>
    <img src="../assets/webcalendar.jpg" />
    <ol>
      <li>Hvis det ikke virker kan du gøre følgende:</li>
      <li>
        I Outlook går du ind på Kalender derefter ind på Værktøj /
        Konto-indstillinger
      </li>
      <li>I Konto-indstillinger vælges Internetkalenderer fanen</li>
      <li>Klik på Ny ... og kopier og indsæt adressen på din kalender:</li>
      <li>{{ generateUrl() }}</li>
      <li>klik Tilføj.</li>
      <li>Du kan derefter gå til abonnementer skærmen.</li>
      <li>Giv kalenderen et navn og beskrivelse, og klik OK.</li>
    </ol>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from "vuex";

export default {
  name: "icalendar-view",
  components: {},
  mounted() {},
  computed: {
    ...mapGetters(["isAdmin", "currentUser", "icalendarKey"]),
  },
  methods: {
    generateUrl() {
      if (window.location.host.indexOf("localhost") !== -1) {
        return (
          "https://localhost:5001/calendar/webICalendar?key=" +
          this.icalendarKey
        );
      }

      return (
        "webcal://staging-api-afloser.vikingdanmark.dk/calendar/webICalendar?key=" +
        this.icalendarKey
      );
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  margin: 15px auto;
  width: 600px;
}

li {
  text-align: left;
}
</style>
